<template>
  <div class="container">
  <div class="row justify-content-end">
    <button
        class="btn btn-danger"
        @click="deleteRow"
        style="margin: 1em">
      Afwezigheid Verwijderen
    </button>
  </div>
  </div>
</template>

<script>
import moment from "moment";
import {mapActions} from "vuex";
import {toYearAndMonth} from "@/util/DateUtil";

export default {
  name: "EditAbsenceAdmin",
  props : ['rowObject'],
  methods: {
    ...mapActions("administrationTimeSheet", [
      'removeAbsence'
    ]),
    deleteRow(){
      const date = moment(this.rowObject.date);
      const dayOfMonth = date.date();
      const yearMonth = toYearAndMonth(date);
      const absenceType = this.rowObject.shift;
      const absenceCategory = absenceType.absenceCategory;
      const fullDay = absenceType.fullDay;
      const removeAbsenceDto = {
        dayOfMonth,
        absenceCategory,
        fullDay
      };
      this.removeAbsence({yearMonth, removeAbsenceDto});
    }
  }
};

</script>

<style scoped>

</style>